
/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ContableRegistroGastoList from './ContableRegistroGastoList';
import {bindActionCreators} from 'redux';
import * as contableregistrogastoActions from '../../actions/contableregistrogastoActions';
import * as paginaActions from '../../actions/paginaActions';
import * as userActions from '../../actions/userActions';
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import {getMargenes} from '../../util/'; 
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {usuarioActual} from '../../util';
import * as menuActions from '../../actions/menuActions';

class ManageContableRegistroGastoList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{},
            permisos:{}
		};
	}

	componentDidMount(){
       
	    usuarioActual(this, "ContableRegistroGasto",true).then( (usuario)=>{
        
            window.scrollTo(0, 0);    
        
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
            this.inicializa();
        
           
         })
        .catch(error=>{
          toastr.error(error);
        });     
		
	}
        
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment  style={margenes}>
                  
                <ContableRegistroGastoList
                    strings={this.state.strings}
                    contableregistrogasto={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
					 form={this.props.form}
                    permisos={this.state.permisos}

                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["ContableRegistroGasto"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["ContableRegistroGasto"]:""}
                 />

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
        listado:state.contableregistrogasto,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        permisos:state.permisos,
        strings:state.strings, 
        form:state.form,
        user:state.user, 
        idioma:state.idioma,
    }

}

function mapDispatchToProps(dispatch){

	return {   
          menuActions:bindActionCreators(menuActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
			listadoActions: bindActionCreators(contableregistrogastoActions, dispatch),
			load:bindActionCreators(contableregistrogastoActions.getContableRegistroGastoList, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageContableRegistroGastoList);